import UserTableRow from './UserTableRow';

export default UserTableRow;
